import '../dist/build/wgw/shared';
import '../dist/build/wgw/worker';
import '../dist/build/wgw/index';

// eslint-disable-next-line no-undef
export default wgw;
